export default [
  {
    path: "/tdot/mitmachen",
    name: "tdotParticipation",
    component: () => import("@/views/guestbook/TdotParticipation.vue"),
    props: (route) => ({ studioCode: typeof route.query.studio === "string" ? route.query.studio : "" }),
    meta: {
      publicTdotParticipation: true,
      hideAppBar: true,
      hideBottomNavigation: true,
      disableChatToasts: true,
      fullWidth: true,
      backgroundColor: "#f3f5f2",
    },
  },
]
